import React from "react";
import "./pageNotFound.scss";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Headings } from "../../atoms/Headings";
import Buttons from "../../atoms/Buttons";
import { useNavigate } from "react-router-dom";
const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <Container fluid className="page-not-found-container">
      <Row>
        <Col lg={12} md={12}>
          <Headings pageTitle={"Page not found"} bigTitle={true} />
        </Col>
      </Row>
      <Row>
        <Col lg={12} md={12} className="mt-5">
          <Card className="page-not-found-content">
            <h2>Sorry, page or document not found...</h2>
            <p>
              We couldn`t find what you were looking for, if the problem
              persists please<span>&nbsp;</span>
              <Buttons
                name="get in touch"
                className="tertiary"
                handleClick={() => navigate("/get-in-touch/")}
              ></Buttons>
              <span>&nbsp;or go back to the&nbsp;</span>
              <Buttons
                name="homepage"
                className="tertiary"
                handleClick={() => navigate("/")}
              ></Buttons>
            </p>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default PageNotFound;
